import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  createURL: 'liveCreationFromTemplate',
  getURL: 'liveTemplatesCatalog',
  attributeName:'templates',
  sessionParams: ['appId', 'areaId'],
  loadPage:'live',
  canEdit: true,
  canOpen: true,
  isSelectable: true,
  isMultiSelectable: false,
  showCreateErrorAsAlert: true,
  editURL: routes.LIVETEMPLATE_EDIT,
  fields: [
    {
      attributeName: 'name',
      helpText: 'Title of the video.',
      label: 'Name',
      canFilter: true,
    },
    {
      attributeName: 'deployment',
      helpText: 'The live template deployment.',
      label: 'Deployment',
      canFilter: true,
    },
    {
      attributeName: 'structure',
      helpText: 'The Live template structure.',
      label: 'Cameras',
      canFilter: true,
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.STATUS,
      helpText: 'Status of Live template.',
      exactWidth: '200px',
      colors: {
        active: 'bg-success',
        deprecated: 'bg-warning',
        inactive: 'bg-danger',
      },
    },
  ],
};
